import { Controller } from "@hotwired/stimulus"
import Masonry from "masonry-layout"
import imagesLoaded from "imagesloaded"

export default class extends Controller {
  static targets = ["container", "item"]
  static values = { ready: Boolean }

  connect() {
    this.element.style.opacity = "0"
    this.initMasonry()
  }

  initMasonry() {
    imagesLoaded(this.element, () => {
      this.masonry = new Masonry(this.element, {
        itemSelector: '.masonry-item',
        columnWidth: '.masonry-item',
        percentPosition: true,
        transitionDuration: 0
      })
      this.readyValue = true
      this.dispatch("ready")
      this.showGrid()
    })
  }

  showGrid() {
    this.element.style.opacity = "1"
    this.itemTargets.forEach((item, index) => {
      setTimeout(() => {
        item.style.opacity = "1"
        item.style.transform = "scale(1)"
      }, index * 50) // Stagger the appearance of items
    })
  }

  layout() {
    if (this.masonry) {
      this.masonry.layout()
    }
  }

  itemAdded(event) {
    const newItem = event.target
    newItem.style.opacity = "0"
    newItem.style.transform = "scale(0.9)"
    imagesLoaded(newItem, () => {
      if (this.masonry) {
        this.masonry.appended(newItem)
        this.masonry.layout()
        setTimeout(() => {
          newItem.style.opacity = "1"
          newItem.style.transform = "scale(1)"
        }, 50)
      }
    })
  }
} 